import Vue from 'vue';
import VueBricodesService from '@/services/VueBricodesService';
import config from '@/config';

const { appId, apiUrl, storageUrl } = config;

Vue.use(VueBricodesService);

export default new VueBricodesService({
  appId,
  apiUrl,
  storageUrl,
});
